import { React, useState } from "react";
import { Col, Card , Button, Container, Row, Form} from 'react-bootstrap';
import FormTransfer from "../FormTransfer/FormTransfer";
import { NFTCard } from "../NFTCard/NFTCardTest";

export default function Collection(props) {
    const [wallet, setWalletAddress] = useState([props._selectedAddress]);
    const [collection, setCollectionAddress] = useState("");
    const [NFTs, setNFTs] = useState([]);
    const [fetchForCollection, setFetchForCollection]=useState(false);

    console.log("Wallet: ", wallet);
  
    const fetchNFTs = async () => {
      let nfts; 
      console.log("fetching nfts");
      const api_key = "IsNndtJbkjgBEfaIkp5cF_zcGZ2eqVUd"
      const baseURL = `https://eth-mainnet.alchemyapi.io/v2/${api_key}/getNFTs/`;
      var requestOptions = {
          method: 'GET'
        };
       
      if (!collection.length) {
        const fetchURL = `${baseURL}?owner=${wallet}`;
        nfts = await fetch(fetchURL, requestOptions).then(data => data.json())
      } else {
        console.log("fetching nfts for collection owned by address")
        const fetchURL = `${baseURL}?owner=${wallet}&contractAddresses%5B%5D=${collection}&pageKey="0-100"`;
        nfts= await fetch(fetchURL, requestOptions).then(data => data.json())
      }
    
      if (nfts) {
        console.log("nfts:", nfts)
        setNFTs(nfts.ownedNfts)
      }
    }
  
    const fetchNFTsForCollection = async () => {
      if (collection.length) {
        var requestOptions = {
          method: 'GET'
        };
        const api_key = "IsNndtJbkjgBEfaIkp5cF_zcGZ2eqVUd"
        const baseURL = `https://eth-mainnet.alchemyapi.io/v2/${api_key}/getNFTsForCollection/`;
        const fetchURL = `${baseURL}?contractAddress=${collection}&withMetadata=${"true"}`;
        const nfts = await fetch(fetchURL, requestOptions).then(data => data.json())
        if (nfts) {
          console.log("NFTs in collection:", nfts)
          setNFTs(nfts.nfts)
        }
      }
    }
  
    return (
      <>
        <Container>
          <Row>
            <Col className="col-6">
              <Card style={{ maxWidth: "50rem", marginBottom: "10px" }}>
                <Card.Header id="card-heading"> Welcome! </Card.Header>
                <Card.Body>
                  <Card.Title>
                    Choose the collection you want to to transfer nfts from. 
                  </Card.Title>
                  <Form
                    className="mb-3"
                    style={{ maxWidth: "50rem", marginleft: "20px" }}
                  >
                    <Form.Group
                      as={Col}
                      className={"col-xs-3"}
                      controlId="formBasicTokenIds"
                    >
                      <Form.Control
                        onChange={(e) => {
                          setCollectionAddress(e.target.value)
                        }}
                        value={collection}
                        type={"text"}
                        placeholder="Add the collection address"
                      />
                      <Form.Text className="text-muted">
                        Input Collection. 
                      </Form.Text>
                    </Form.Group>
                  </Form>
                </Card.Body>
              </Card>
              <Card style={{ maxWidth: "50rem", marginTop: "10px" }}>
                <Card.Header id="card-heading"> Add receiver accounts and token Ids </Card.Header>
                <Card.Body>
                  <Form.Text className="text-muted">
                    Collection: {collection}
                  </Form.Text>  
                  <FormTransfer 
                    props={collection}
                  />
                  <Card.Title style={{ fontSize: "1.5em" }}></Card.Title>
                  <Card.Text style={{ fontSize: "small" }}>
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            <Col className='col-6'>
              <Card style={{ maxWidth: "50rem", marginleft: "20px" }}>
                <Card.Header id="card-heading"> Fetch all NFTs from your wallet! </Card.Header>
                <Card.Body>
                  <Form
                    className="mb-3"
                    style={{ maxWidth: "50rem", marginleft: "20px" }}
                  >
                    <Form.Group
                      as={Col}
                      className="mb-3"
                      controlId="formBasicAddress"
                    >
                      <Form.Label className="sm-2">
                        Input your wallet address
                      </Form.Label>
                      <Form.Control
                        disabled={fetchForCollection}
                        onChange={(e) => {
                          setWalletAddress(e.target.value)
                        }}
                        value={wallet}
                        type={"text"}
                        placeholder="Add your wallet address"
                      />
                      <Form.Text className="text-muted">
                        Input address.
                      </Form.Text>
                    </Form.Group>

                    <Form.Group
                      as={Col}
                      className="mb-3"
                      controlId="formBasicTokenIds"
                    >
                      <Form.Label>Input Collection Address</Form.Label>
                      <Form.Control
                        onChange={(e) => {
                          setCollectionAddress(e.target.value)
                        }}
                        value={collection}
                        type={"text"}
                        placeholder="Add the collection address"
                      />
                      <Form.Text className="text-muted">
                        Input Collection.
                      </Form.Text>
                    </Form.Group>
                    <Form.Label className="text-gray-600 ">Fetch entire collection </Form.Label>
                    <Form.Check
                      onChange={(e) => {
                        setFetchForCollection(e.target.checked)
                      }}
                      type={"checkbox"}
                      className="mr-2"
                    />
                    <Button className={"disabled:bg-slate-500 text-white bg-blue-400 px-4 py-2 mt-3 rounded-sm w-1/5"} id="buttons" onClick={
                      () => {
                        if (fetchForCollection) {
                          fetchNFTsForCollection()
                        } else fetchNFTs()
                      }
                    } 
                    variant="warning"
                    >Let's go!
                    </Button>
                  </Form>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          <Row xs={1} md={2} lg={3} className="g-4 justify-content-center" style={{marginTop: "10px"}} >
            {
              NFTs.length && NFTs.map(nft => {
                return (
                  <NFTCard 
                    _nft={nft}
                
                    ></NFTCard>
                  )
                })
              }
          </Row>
          </Container>


      </>
    );
}


